const rolesActionTypes = {
  SET_ROLES: 'SET_ROLES',
  REMOVE_ALL_ROLES: 'REMOVE_ALL_ROLES',
};
export default rolesActionTypes;
